import {
    CONFIRM_SETUP_INTENT_START,
    CONFIRM_SETUP_INTENT_SUCCESS,
    CONFIRM_SETUP_INTENT_ERROR
} from '../../constants';
import { setLoaderComplete } from '../loader/loader';
import showToaster from '../../helpers/toastrMessgaes/showToaster';
import history from '../../history';
import { confirmSetupIntent as mutation, getPaymentMethod as query } from '../../lib/graphql';

export function confirmSetupIntentAction({ setupIntentId, paymentMethodId, cardLastFour, orderId, bookingId }) {
    return async (dispatch, getState, { client }) => {
        try {
            dispatch({
                type: CONFIRM_SETUP_INTENT_START,
            });

            const { data } = await client.mutate({
                mutation,
                variables: {
                    setupIntentId,
                    paymentMethod: paymentMethodId,
                    cardLastFour
                },
                refetchQueries: [{ query }]
            });

            if (data?.confirmSetupIntent?.result?.requireAdditionalAction) {
                let errorMessage = data?.confirmSetupIntent?.errorMessage
                showToaster({ messageId: 'catchMessage', requestContent: errorMessage, toasterType: 'error' });
                setLoaderComplete('addCardDetails');
                dispatch({
                    type: CONFIRM_SETUP_INTENT_ERROR,
                });
            } else {
                dispatch(setLoaderComplete('addCardDetails'))
                orderId
                    ? history.push(`/order/${orderId}`)
                    : (bookingId
                        ? history.push(`/tracking/${bookingId}`)
                        : history.push('/payment-method'));

                await showToaster({ messageId: 'cardAddSuccess', toasterType: 'success' });
                dispatch({
                    type: CONFIRM_SETUP_INTENT_SUCCESS,
                });
            }
        } catch (error) {
            dispatch({
                type: CONFIRM_SETUP_INTENT_ERROR,
            });
            dispatch(setLoaderComplete('addCardDetails'));
            return {
                status: '400'
            };
        }
        return {
            status: '200'
        };
    };
}